module.exports = __webpack_public_path__ + "media/Video 42b.f8fd057c.mp4";